export type TextComponentType = 'regular-text' | 'link' | 'mention' | 'tag'

export interface TextComponent {
    type: TextComponentType
    text: string
}

const testForTrigger = (text: string, trigger: string): boolean => {
    const newLineRegex = /[\r\n]+/
    const cleanedUpText = text.replace(newLineRegex, '')
    const triggerOccurrencesInTextCount = cleanedUpText.split(trigger).length - 1
    const textContainsMoreThanTrigger = cleanedUpText.length > trigger.length
    return textContainsMoreThanTrigger
        && cleanedUpText.startsWith(trigger)
        && triggerOccurrencesInTextCount === 1
}

export const determineTextType = (text: string): TextComponentType => {
    const mentionTrigger = '@'
    if (testForTrigger(text, mentionTrigger)) {
        return 'mention'
    }

    const tagTrigger = '#'
    if (testForTrigger(text, tagTrigger)) {
        return 'tag'
    }

    const httpTrigger = 'http://'
    if (testForTrigger(text, httpTrigger)) {
        return 'link'
    }

    const httpsTrigger = 'https://'
    if (testForTrigger(text, httpsTrigger)) {
        return 'link'
    }

    return 'regular-text'
}

const removeLastCharcter = (text: string) => text.substring(0, text.length - 1)

export const splitTextToComponents = (text: string): TextComponent[] => {
    return text.split(' ').map(x => {
        if (x.includes('\n')) {
            const result = x.split('\n').map(x => ({
                type: determineTextType(x),
                text: x + '\n'
            }))
            const lastElement = result[result.length - 1]
            lastElement.text = removeLastCharcter(lastElement.text)
            return result
        }
        return [{
            type: determineTextType(x),
            text: x ? x : ' '
        }]
    }).flatMap(x => x)
}